// extracted by mini-css-extract-plugin
export default {"header":"actSetupSubActionHeader_header__70dAX","fixedHeader":"actSetupSubActionHeader_fixedHeader__1aW3r"};